import { IApplicationConfiguration } from '../../interfaces/scheduler_interfaces';

export class RegistrationAttributesFacade {
  constructor(private appConfigModel: IApplicationConfiguration) {}

  isFeatureEnabled() {
    return this.appConfigModel.isFeatureEnabled('reg-configurable_attribute') === true;
  }
}

angular.module('capability-ng-scheduler').service('ngRegistrationAttributesFacade', RegistrationAttributesFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_attributes/facades/registration_attributes_facade.ts